import type { BookingDocument, BookingDocumentSubType, BookingDocumentType } from '../../domain/types'
import type { BookingDocumentsAPIResponse } from '../types'

export function documentsMapper(apiResponse: BookingDocumentsAPIResponse): BookingDocument[] {
  return (apiResponse.documents ?? []).filter(doc => doc.url).map(doc => ({
    title: doc.title ?? '',
    subtitle: doc.name ?? '',
    url: doc.url as string,
    type: doc.type as BookingDocumentType | undefined,
    subType: doc.subtype as BookingDocumentSubType | undefined,
  }))
}
